<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container'">
    <div class="mt-2" style="max-width:597px">
      <h3 style="padding-right: 60px">Endre rekkefølgen av grupper for valg og tillegg</h3>
      <div class="dragndrop-info">
        <!-- One sentence per pointer: a finger has to hold first, a mouse does not, and telling
             either one the other's gesture is how «sorteringen virker ikke» starts. -->
        <span class="bo_pointer-fine">Dra og slipp radene for å endre rekkefølgen på gruppene.</span>
        <span class="bo_pointer-coarse">Hold fingeren på en rad til den løfter seg, og dra den dit du vil — slik endrer
          du rekkefølgen på gruppene. Sveiper du raskt, ruller listen i stedet.</span>
        Til slutt trykker du på &laquo;Lagre&raquo; nederst.
      </div>

      <ul id="addOnGroupsList" class="bo_categoriesList">
        <li v-for="addOnGroup in addOnGroups" :key="addOnGroup.id" :id="addOnGroup.id" class="addOnGroup-row">
          <span class="bo_drag-handle"><font-awesome-icon :icon="['fas', 'grip-lines']"/></span>
            <span class="bo_row-label">{{ addOnGroup.name }}</span>
            <span class="bo_row-move">
              <button type="button" class="icon-btn" aria-label="Flytt opp" @click="moveRowUp($event)"><font-awesome-icon :icon="['fas', 'chevron-up']"/></button>
              <button type="button" class="icon-btn" aria-label="Flytt ned" @click="moveRowDown($event)"><font-awesome-icon :icon="['fas', 'chevron-down']"/></button>
            </span>
        </li>
      </ul>

      <div class="bo_savebtn_container">
        <hr/>
        <button type="button" class="bo_btn" @click="saveOrderOfCategories">Lagre</button>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ProductService from "@/services/product/ProductService";
import Sortable from 'sortablejs';
import sortableOptions from "@/util/SortableOptions";
import { moveRowUp, moveRowDown } from "@/util/RowReorder";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,
      addOnGroups : []
    };
  },
  mounted() {
    ProductService.getAddOnGroups().then(
        (response) => {
          this.addOnGroups = response.data;

          this.$nextTick(() => {
            let el = document.getElementById('addOnGroupsList');
            Sortable.create(el, sortableOptions());
          });

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  methods: {
    // Reordering without a drag — see RowReorder.js for why these move the DOM.
    moveRowUp,
    moveRowDown,

    updateSortOrder(addOnGroupId, sortOrder) {
      //console.log(sortOrder + ' : ' + addOnGroupId);
      for (var i = 0; i < this.addOnGroups.length; i++) {
        if (this.addOnGroups[i].id == addOnGroupId) {
          this.addOnGroups[i].sortOrder = sortOrder;
          break; //Stop this loop, we found it!
        }
      }
    },
    saveOrderOfCategories(){
      this.loading = true;

      let listItems = document.getElementById('addOnGroupsList').getElementsByTagName('li');
      for (var i = 0; i < listItems.length; i++) {
        let li = listItems[i];
        let addOnGroupId = li.getAttribute('id');
        this.updateSortOrder(addOnGroupId, i);
      }

      ProductService.editAddOnGroups(this.addOnGroups).then(
          (response) => {
            if(response.data === "SUCCEEDED"){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Updating sortOrder of addOnGroups failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
